import React, { useState, useEffect, useRef } from "react";
import "./Header.css";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [currentMobileMenu, setCurrentMobileMenu] = useState("main");
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const searchInputRef = useRef(null);

  // Estados para mega menús desktop (hover)
  const [menuVisible, setMenuVisible] = useState(false);
  const [solutionsMenuVisible, setSolutionsMenuVisible] = useState(false);
  const [clientesMenuVisible, setClientesMenuVisible] = useState(false);
  const [sostenibilidadMenuVisible, setSostenibilidadMenuVisible] = useState(false);
  const [responsabilidadMenuVisible, setResponsabilidadMenuVisible] = useState(false);

  const [menuHeight, setMenuHeight] = useState("auto");
  const [prevMenuHeight, setPrevMenuHeight] = useState("auto");

  const menuButtonRef = useRef(null);
  const menuButtonRef2 = useRef(null);
  const menuButtonRef3 = useRef(null);
  const menuButtonRef4 = useRef(null);
  const menuButtonRef5 = useRef(null);

  const menuWrapperRef = useRef(null);
  const solutionsMenuWrapperRef = useRef(null);
  const clientesWrapperRef = useRef(null);
  const sostenibilidadWrapperRef = useRef(null);
  const responsabilidadWrapperRef = useRef(null);

  const submenuRef1 = useRef(null);
  const submenuRef2 = useRef(null);
  const submenuRef3 = useRef(null);
  const submenuRef4 = useRef(null);
  const submenuRef5 = useRef(null);

  const hoverTimeoutRef = useRef(null);
  const baseAssets = process.env.PUBLIC_URL || "";

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setCurrentMobileMenu("main");
  };

  const openSubMenu = (menuName) => setCurrentMobileMenu(menuName);
  const goBackToMainMenu = (menuName) => setCurrentMobileMenu(menuName);

  const openSearch = () => {
    setIsSearchOpen(true);
    setTimeout(() => searchInputRef.current?.focus(), 100);
  };

  const closeSearch = () => {
    setIsSearchOpen(false);
    setSearchQuery("");
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.location.href = `https://www.holcim.com.mx/?s=${encodeURIComponent(searchQuery)}`;
    }
  };

  useEffect(() => {
    if (isMobileMenuOpen) document.body.classList.add("no-scroll");
    else document.body.classList.remove("no-scroll");
    return () => document.body.classList.remove("no-scroll");
  }, [isMobileMenuOpen]);

  useEffect(() => {
    if (isSearchOpen) document.body.classList.add("no-scroll");
    else document.body.classList.remove("no-scroll");
    return () => document.body.classList.remove("no-scroll");
  }, [isSearchOpen]);

  const handleMenuMouseEnter = (setter) => {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    setter(true);
  };

  const handleMenuMouseLeave = (setter) => {
    hoverTimeoutRef.current = setTimeout(() => setter(false), 150);
  };

  const handleMenuToggle = (e) => {
    e?.preventDefault();
    setPrevMenuHeight(menuWrapperRef.current?.scrollHeight || 0);
    setMenuVisible((v) => !v);
  };

  const handleSolutionsMenuToggle = (e) => {
    e?.preventDefault();
    setPrevMenuHeight(solutionsMenuWrapperRef.current?.scrollHeight || 0);
    setSolutionsMenuVisible((v) => !v);
  };

  const handleClientesMenuToggle = (e) => {
    e?.preventDefault();
    setPrevMenuHeight(clientesWrapperRef.current?.scrollHeight || 0);
    setClientesMenuVisible((v) => !v);
  };

  const handleSostenibilidadMenuToggle = (e) => {
    e?.preventDefault();
    setPrevMenuHeight(sostenibilidadWrapperRef.current?.scrollHeight || 0);
    setSostenibilidadMenuVisible((v) => !v);
  };

  const handleResponsabilidadMenuToggle = (e) => {
    e?.preventDefault();
    setPrevMenuHeight(responsabilidadWrapperRef.current?.scrollHeight || 0);
    setResponsabilidadMenuVisible((v) => !v);
  };

  const handleItemMenuClick = (submenu) => {
    setPrevMenuHeight(menuHeight);
    const submenuHeight = submenu.current?.scrollHeight || 0;
    setMenuHeight(submenuHeight);
  };

  const handleBackBtnClick = () => setMenuHeight(prevMenuHeight);

  const handleClickOutside = (event) => {
    if (
      menuWrapperRef.current &&
      !menuWrapperRef.current.contains(event.target) &&
      !menuButtonRef.current?.contains(event.target)
    )
      setMenuVisible(false);
    if (
      solutionsMenuWrapperRef.current &&
      !solutionsMenuWrapperRef.current.contains(event.target) &&
      !menuButtonRef2.current?.contains(event.target)
    )
      setSolutionsMenuVisible(false);
    if (
      clientesWrapperRef.current &&
      !clientesWrapperRef.current.contains(event.target) &&
      !menuButtonRef3.current?.contains(event.target)
    )
      setClientesMenuVisible(false);
    if (
      sostenibilidadWrapperRef.current &&
      !sostenibilidadWrapperRef.current.contains(event.target) &&
      !menuButtonRef4.current?.contains(event.target)
    )
      setSostenibilidadMenuVisible(false);
    if (
      responsabilidadWrapperRef.current &&
      !responsabilidadWrapperRef.current.contains(event.target) &&
      !menuButtonRef5.current?.contains(event.target)
    )
      setResponsabilidadMenuVisible(false);
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const baseUrl = "https://www.holcim.com.mx";

  return (
    <header className="holcim-header">
      {/* ========== DESKTOP HEADER ========== */}
      <div className="holcim-header-desktop">
        <div className="header-container">
          {/* Fila superior: solo enlaces secundarios, alineados a la derecha */}
          <div className="header-top-row">
            <div className="top-links-wrapper">
              <a href={`${baseUrl}/historias-latam`}>HISTORIAS LATAM</a>
              <a href={`${baseUrl}/donde-estamos`}>UBICACIONES</a>
              <a href={`${baseUrl}/noticias`}>PRENSA</a>
              <a href={`${baseUrl}/carreras`}>CARRERAS</a>
              <a href={`${baseUrl}/contacto`}>CONTACTO</a>
            </div>
          </div>

          {/* Fila principal: logo (icono + HOLCIM + MÉXICO) | navegación | búsqueda */}
          <div className="header-main-row">
            <div className="site-logo-wrapper">
              <a href={`${baseUrl}/`} aria-label="Holcim México" className="logo-and-country">
                <img
                  src={`${baseAssets}/assets/icons/holcim.png`}
                  alt=""
                  className="logo-icon"
                />
                <span className="logo-text">HOLCIM</span>
                <span className="country">MÉXICO</span>
              </a>
            </div>

            <div className="nav-and-search">
              <ul className="holcim-menu">
                  <li
                    ref={menuButtonRef}
                    onMouseEnter={() => handleMenuMouseEnter(setMenuVisible)}
                    onMouseLeave={() => handleMenuMouseLeave(setMenuVisible)}
                  >
                    <a href={`${baseUrl}/quienes-somos`}>NOSOTROS</a>
                    {menuVisible && (
                      <div
                        ref={menuWrapperRef}
                        className="mega-menu-wrapper"
                        onMouseEnter={() => setMenuVisible(true)}
                        onMouseLeave={() => setMenuVisible(false)}
                      >
                        <div className="mega-menu-header">
                          <button
                            type="button"
                            className="mega-menu-back"
                            onClick={() => setMenuVisible(false)}
                          >
                            ← Nosotros
                          </button>
                        </div>
                        <div className="mega-menu-content">
                          <h4 className="mega-menu-title">Nosotros</h4>
                          <ul className="mega-menu-list">
                            <li>
                              <a href={`${baseUrl}/quienes-somos`}>
                                Quiénes Somos
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/linea-de-tiempo`}>
                                Historia (Línea de Tiempo)
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/donde-estamos`}>
                                ¿Dónde Estamos?
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/holcim-en-cifras`}>
                                Holcim en Cifras
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/estructura-organizacional`}>
                                Estructura Organizacional
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/que-hacemos`}>
                                ¿Qué Hacemos?
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/holcim-en-el-mundo`}>
                                Grupo Holcim
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/nextgen-growth-2030`}>
                                Estrategia 2030
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/gobierno-corporativo`}>
                                Cumplimiento Ético (Compliance)
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/nuestra-vision-y-valores`}>
                                Nuestra Visión y Valores
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/contacto`}>Contacto</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </li>

                  <li
                    ref={menuButtonRef2}
                    onMouseEnter={() =>
                      handleMenuMouseEnter(setSolutionsMenuVisible)
                    }
                    onMouseLeave={() =>
                      handleMenuMouseLeave(setSolutionsMenuVisible)
                    }
                  >
                    <a href={`${baseUrl}/nuestras-soluciones`}>
                      SOLUCIONES Y PRODUCTOS
                    </a>
                    {solutionsMenuVisible && (
                      <div
                        ref={solutionsMenuWrapperRef}
                        className="mega-menu-wrapper mega-menu-solutions"
                        onMouseEnter={() => setSolutionsMenuVisible(true)}
                        onMouseLeave={() => setSolutionsMenuVisible(false)}
                      >
                        <div className="mega-menu-header">
                          <button
                            type="button"
                            className="mega-menu-back"
                            onClick={() => setSolutionsMenuVisible(false)}
                          >
                            ← Soluciones y Productos
                          </button>
                        </div>
                        <div className="mega-menu-content">
                          <h4 className="mega-menu-title">
                            Soluciones y Productos
                          </h4>
                          <ul className="mega-menu-list">
                            <li>
                              <a href={`${baseUrl}/soluciones-concretas`}>
                                Soluciones Concretas
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/geocycle`}>Geocycle</a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/citec`}>CiTeC</a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/cemento`}>Cemento</a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/agregados`}>Agregados</a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/innovacion`}>
                                Innovación →
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </li>

                  <li
                    ref={menuButtonRef3}
                    onMouseEnter={() =>
                      handleMenuMouseEnter(setClientesMenuVisible)
                    }
                    onMouseLeave={() =>
                      handleMenuMouseLeave(setClientesMenuVisible)
                    }
                  >
                    <a href={`${baseUrl}/clientes`}>CLIENTES</a>
                    {clientesMenuVisible && (
                      <div
                        ref={clientesWrapperRef}
                        className="mega-menu-wrapper"
                        onMouseEnter={() => setClientesMenuVisible(true)}
                        onMouseLeave={() => setClientesMenuVisible(false)}
                      >
                        <div className="mega-menu-header">
                          <button
                            type="button"
                            className="mega-menu-back"
                            onClick={() => setClientesMenuVisible(false)}
                          >
                            ← Clientes
                          </button>
                        </div>
                        <div className="mega-menu-content">
                          <h4 className="mega-menu-title">Clientes</h4>
                          <ul className="mega-menu-list">
                            <li>
                              <a href={`${baseUrl}/disensa`}>Disensa</a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/segmento-industrial`}>
                                Segmento Industrial
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/segmento-infraestructura`}>
                                Segmento Infraestructura
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/segmento-edificacion`}>
                                Segmento Edificación
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/segmento-distribucion`}>
                                Segmento Distribución
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/segmento-retail`}>
                                Segmento Retail
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/club-de-compras`}>
                                Club De Compras
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/programas`}>PrograMÁS</a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/aliados`}>Aliados</a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/quieres-ser-distribuidor`}>
                                ¿Quieres ser Distribuidor?
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </li>

                  <li
                    ref={menuButtonRef4}
                    onMouseEnter={() =>
                      handleMenuMouseEnter(setSostenibilidadMenuVisible)
                    }
                    onMouseLeave={() =>
                      handleMenuMouseLeave(setSostenibilidadMenuVisible)
                    }
                  >
                    <a href={`${baseUrl}/nuestro-compromiso`}>
                      SOSTENIBILIDAD
                    </a>
                    {sostenibilidadMenuVisible && (
                      <div
                        ref={sostenibilidadWrapperRef}
                        className="mega-menu-wrapper"
                        onMouseEnter={() =>
                          setSostenibilidadMenuVisible(true)
                        }
                        onMouseLeave={() =>
                          setSostenibilidadMenuVisible(false)
                        }
                      >
                        <div className="mega-menu-header">
                          <button
                            type="button"
                            className="mega-menu-back"
                            onClick={() => setSostenibilidadMenuVisible(false)}
                          >
                            ← Sostenibilidad
                          </button>
                        </div>
                        <div className="mega-menu-content">
                          <h4 className="mega-menu-title">Sostenibilidad</h4>
                          <ul className="mega-menu-list">
                            <li>
                              <a href={`${baseUrl}/nuestro-compromiso`}>
                                Nuestro Compromiso
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/nuestra-hoja-de-ruta`}>
                                Nuestra Hoja de Ruta
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/nuestra-huella-de-co2`}>
                                Nuestra Huella de CO2
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/economia-circular`}>
                                Economía Circular
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/medio-ambiente`}>
                                Medio Ambiente
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/gente-comunidades-y-derechos-humanos`}>
                                Gente, Comunidades y Derechos Humanos
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/alianzas-y-reconocimientos`}>
                                Alianzas y Reconocimientos
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/holcim-foundation`}>
                                Holcim Foundation
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/building-icons`}>
                                Building Icons
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </li>

                  <li
                    ref={menuButtonRef5}
                    onMouseEnter={() =>
                      handleMenuMouseEnter(setResponsabilidadMenuVisible)
                    }
                    onMouseLeave={() =>
                      handleMenuMouseLeave(setResponsabilidadMenuVisible)
                    }
                  >
                    <a href={`${baseUrl}/fundacion-holcim-mexico-ac`}>
                      RESPONSABILIDAD SOCIAL
                    </a>
                    {responsabilidadMenuVisible && (
                      <div
                        ref={responsabilidadWrapperRef}
                        className="mega-menu-wrapper"
                        onMouseEnter={() =>
                          setResponsabilidadMenuVisible(true)
                        }
                        onMouseLeave={() =>
                          setResponsabilidadMenuVisible(false)
                        }
                      >
                        <div className="mega-menu-header">
                          <button
                            type="button"
                            className="mega-menu-back"
                            onClick={() => setResponsabilidadMenuVisible(false)}
                          >
                            ← Responsabilidad Social
                          </button>
                        </div>
                        <div className="mega-menu-content">
                          <h4 className="mega-menu-title">
                            Responsabilidad Social
                          </h4>
                          <ul className="mega-menu-list">
                            <li>
                              <a href={`${baseUrl}/fundacion-holcim-mexico-ac`}>
                                Fundación Holcim México A.C.
                              </a>
                            </li>
                            <li>
                              <a href={`${baseUrl}/escuela-mexicana-de-la-construccion`}>
                                Escuela Mexicana de la Construcción
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </li>

                  <li className="search-icon-li">
                    <button
                      type="button"
                      className="search-icon-btn"
                      onClick={openSearch}
                      aria-label="Buscar"
                    >
                      <img
                        src={`${baseAssets}/assets/icons/search.svg`}
                        alt="Buscar"
                        className="search-icon"
                      />
                    </button>
                  </li>
                </ul>
            </div>
          </div>
        </div>
      </div>

      {/* ========== SEARCH OVERLAY ========== */}
      {isSearchOpen && (
        <div className="search-overlay">
          <div className="search-overlay-content">
            <div className="search-overlay-left">
              <img
                src="/assets/icons/search.svg"
                alt=""
                className="search-overlay-icon"
              />
              <form onSubmit={handleSearchSubmit} className="search-form">
                <label htmlFor="search-input" className="search-label">
                  Search
                </label>
                <input
                  ref={searchInputRef}
                  id="search-input"
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder=""
                  className="search-input"
                />
              </form>
            </div>
            <button
              type="button"
              className="close-search-btn"
              onClick={closeSearch}
            >
              <span>CLOSE</span>
              <span>SEARCH</span>
            </button>
          </div>
        </div>
      )}

      {/* ========== MOBILE HEADER ========== */}
      <div className="holcim-header-mobile">
        <div className="header-container mobile">
          <div className="logo-wrapper">
            <a href={`${baseUrl}/`} aria-label="Holcim México" className="logo-and-country mobile">
              <img
                src={`${baseAssets}/assets/icons/holcim.png`}
                alt=""
                className="logo-icon"
              />
              <span className="logo-text">HOLCIM</span>
              <span className="country">MÉXICO</span>
            </a>
          </div>
          <div className="right-wrapper">
            <button
              type="button"
              className={`hamburger ${isMobileMenuOpen ? "open" : ""}`}
              onClick={toggleMobileMenu}
              aria-label="Toggle menu"
            >
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </button>
          </div>
        </div>

        {/* Menú móvil completo */}
        {isMobileMenuOpen && (
          <div className="fullscreen-menu">
            <div className="mobile-menu-corporate-border"></div>
            <div className="menu-content">
              {currentMobileMenu === "main" && (
                <>
                  <ul className="main-menu">
                    <li>
                      <a
                        className="menu-item mobile first"
                        onClick={() => openSubMenu("nosotros")}
                      >
                        Nosotros
                        <img
                          className="icon"
                          src="/assets/icons/arrow_right.svg"
                          alt=""
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        className="menu-item mobile"
                        onClick={() => openSubMenu("soluciones-y-productos")}
                      >
                        Soluciones y Productos
                        <img
                          className="icon"
                          src="/assets/icons/arrow_right.svg"
                          alt=""
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        className="menu-item mobile"
                        onClick={() => openSubMenu("clientes")}
                      >
                        Clientes
                        <img
                          className="icon"
                          src="/assets/icons/arrow_right.svg"
                          alt=""
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        className="menu-item mobile"
                        onClick={() => openSubMenu("sostenibilidad")}
                      >
                        Sostenibilidad
                        <img
                          className="icon"
                          src="/assets/icons/arrow_right.svg"
                          alt=""
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        className="menu-item mobile"
                        onClick={() => openSubMenu("responsabilidad-social")}
                      >
                        Responsabilidad Social
                        <img
                          className="icon"
                          src="/assets/icons/arrow_right.svg"
                          alt=""
                        />
                      </a>
                    </li>
                  </ul>
                  <hr />
                  <ul className="secondary-menu">
                    <li>
                      <a
                        className="mobile-secundary-menu"
                        href={`${baseUrl}/historias-latam`}
                      >
                        Historias Latam
                      </a>
                    </li>
                    <li>
                      <a
                        className="mobile-secundary-menu"
                        href={`${baseUrl}/donde-estamos`}
                      >
                        Ubicaciones
                      </a>
                    </li>
                    <li>
                      <a
                        className="mobile-secundary-menu"
                        href={`${baseUrl}/noticias`}
                      >
                        Prensa
                      </a>
                    </li>
                    <li>
                      <a
                        className="mobile-secundary-menu"
                        href={`${baseUrl}/carreras`}
                      >
                        Carreras
                      </a>
                    </li>
                    <li>
                      <a
                        className="mobile-secundary-menu"
                        href={`${baseUrl}/contacto`}
                      >
                        Contacto
                      </a>
                    </li>
                  </ul>
                </>
              )}

              {currentMobileMenu === "nosotros" && (
                <div className="submenu">
                  <a
                    className="back-button"
                    onClick={() => goBackToMainMenu("main")}
                  >
                    <img
                      className="back-arrow"
                      src="/assets/icons/arrow_right.svg"
                      alt=""
                    />
                    Main menu
                  </a>
                  <div className="subMenuTitle">
                    <h3>Nosotros</h3>
                  </div>
                  <ul>
                    <li>
                      <a
                        className="submenu-item"
                        onClick={() => openSubMenu("quienes-somos")}
                      >
                        Quiénes Somos
                        <img
                          className="icon"
                          src="/assets/icons/arrow_right.svg"
                          alt=""
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        onClick={() => openSubMenu("grupo-holcim")}
                      >
                        Grupo Holcim
                        <img
                          className="icon"
                          src="/assets/icons/arrow_right.svg"
                          alt=""
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/nextgen-growth-2030`}
                      >
                        Estrategia 2030
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/gobierno-corporativo`}
                      >
                        Cumplimiento Ético (Compliance)
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/nuestra-vision-y-valores`}
                      >
                        Nuestra Visión y Valores
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/contacto`}
                      >
                        Contacto
                      </a>
                    </li>
                  </ul>
                </div>
              )}

              {currentMobileMenu === "quienes-somos" && (
                <div className="submenu">
                  <a
                    className="back-button"
                    onClick={() => goBackToMainMenu("nosotros")}
                  >
                    <img
                      className="back-arrow"
                      src="/assets/icons/arrow_right.svg"
                      alt=""
                    />
                    Nosotros
                  </a>
                  <div className="subMenuTitle">
                    <h3>Quiénes Somos</h3>
                  </div>
                  <ul>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/linea-de-tiempo`}
                      >
                        Historia (Línea de Tiempo)
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/donde-estamos`}
                      >
                        ¿Dónde Estamos?
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/holcim-en-cifras`}
                      >
                        Holcim en Cifras
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/estructura-organizacional`}
                      >
                        Estructura Organizacional
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/que-hacemos`}
                      >
                        ¿Qué Hacemos?
                      </a>
                    </li>
                  </ul>
                </div>
              )}

              {currentMobileMenu === "grupo-holcim" && (
                <div className="submenu">
                  <a
                    className="back-button"
                    onClick={() => goBackToMainMenu("nosotros")}
                  >
                    <img
                      className="back-arrow"
                      src="/assets/icons/arrow_right.svg"
                      alt=""
                    />
                    Nosotros
                  </a>
                  <div className="subMenuTitle">
                    <h3>Grupo Holcim</h3>
                  </div>
                  <ul>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/presencia-mundial`}
                      >
                        Presencia Mundial
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/ultimas-noticias-grupo-holcim`}
                      >
                        Últimas Noticias Grupo Holcim
                      </a>
                    </li>
                  </ul>
                </div>
              )}

              {currentMobileMenu === "soluciones-y-productos" && (
                <div className="submenu">
                  <a
                    className="back-button"
                    onClick={() => goBackToMainMenu("main")}
                  >
                    <img
                      className="back-arrow"
                      src="/assets/icons/arrow_right.svg"
                      alt=""
                    />
                    Main menu
                  </a>
                  <div className="subMenuTitle">
                    <h3>Soluciones y Productos</h3>
                  </div>
                  <ul>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/soluciones-concretas`}
                      >
                        Soluciones Concretas
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/geocycle`}
                      >
                        Geocycle
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/citec`}
                      >
                        CiTeC
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/cemento`}
                      >
                        Cemento
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/agregados`}
                      >
                        Agregados
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/innovacion`}
                      >
                        Innovación →
                      </a>
                    </li>
                  </ul>
                </div>
              )}

              {currentMobileMenu === "clientes" && (
                <div className="submenu">
                  <a
                    className="back-button"
                    onClick={() => goBackToMainMenu("main")}
                  >
                    <img
                      className="back-arrow"
                      src="/assets/icons/arrow_right.svg"
                      alt=""
                    />
                    Main menu
                  </a>
                  <div className="subMenuTitle">
                    <h3>Clientes</h3>
                  </div>
                  <ul>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/disensa`}
                      >
                        Disensa
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        onClick={() => openSubMenu("segmentos-de-mercado")}
                      >
                        Segmentos de Mercado
                        <img
                          className="icon"
                          src="/assets/icons/arrow_right.svg"
                          alt=""
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/club-de-compras`}
                      >
                        Club De Compras
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/programas`}
                      >
                        PrograMÁS
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/aliados`}
                      >
                        Aliados
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/quieres-ser-distribuidor`}
                      >
                        ¿Quieres ser Distribuidor?
                      </a>
                    </li>
                  </ul>
                </div>
              )}

              {currentMobileMenu === "segmentos-de-mercado" && (
                <div className="submenu">
                  <a
                    className="back-button"
                    onClick={() => goBackToMainMenu("clientes")}
                  >
                    <img
                      className="back-arrow"
                      src="/assets/icons/arrow_right.svg"
                      alt=""
                    />
                    Clientes
                  </a>
                  <div className="subMenuTitle">
                    <h3>Segmentos de Mercado</h3>
                  </div>
                  <ul>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/segmento-industrial`}
                      >
                        Segmento Industrial
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/segmento-infraestructura`}
                      >
                        Segmento Infraestructura
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/segmento-edificacion`}
                      >
                        Segmento Edificación
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/segmento-distribucion`}
                      >
                        Segmento Distribución
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/segmento-retail`}
                      >
                        Segmento Retail
                      </a>
                    </li>
                  </ul>
                </div>
              )}

              {currentMobileMenu === "sostenibilidad" && (
                <div className="submenu">
                  <a
                    className="back-button"
                    onClick={() => goBackToMainMenu("main")}
                  >
                    <img
                      className="back-arrow"
                      src="/assets/icons/arrow_right.svg"
                      alt=""
                    />
                    Main menu
                  </a>
                  <div className="subMenuTitle">
                    <h3>Sostenibilidad</h3>
                  </div>
                  <ul>
                    <li>
                      <a
                        className="submenu-item"
                        onClick={() => openSubMenu("net-zero")}
                      >
                        net-zero
                        <img
                          className="icon"
                          src="/assets/icons/arrow_right.svg"
                          alt=""
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/economia-circular`}
                      >
                        Economía Circular
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/medio-ambiente`}
                      >
                        Medio Ambiente
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/gente-comunidades-y-derechos-humanos`}
                      >
                        Gente, Comunidades y Derechos Humanos
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/alianzas-y-reconocimientos`}
                      >
                        Alianzas y Reconocimientos
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/holcim-foundation`}
                      >
                        Holcim Foundation
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/building-icons`}
                      >
                        Building Icons
                      </a>
                    </li>
                  </ul>
                </div>
              )}

              {currentMobileMenu === "net-zero" && (
                <div className="submenu">
                  <a
                    className="back-button"
                    onClick={() => goBackToMainMenu("sostenibilidad")}
                  >
                    <img
                      className="back-arrow"
                      src="/assets/icons/arrow_right.svg"
                      alt=""
                    />
                    Sostenibilidad
                  </a>
                  <div className="subMenuTitle">
                    <h3>net-zero</h3>
                  </div>
                  <ul>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/nuestro-compromiso`}
                      >
                        Nuestro Compromiso
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/nuestra-hoja-de-ruta`}
                      >
                        Nuestra Hoja de Ruta
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/nuestra-huella-de-co2`}
                      >
                        Nuestra Huella de CO2
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/nuestras-acciones-climaticas-hoy`}
                      >
                        Nuestras Acciones Climáticas hoy
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/nuestras-soluciones-de-construccion-ecologica`}
                      >
                        Nuestras Soluciones de Construcción Ecológica
                      </a>
                    </li>
                  </ul>
                </div>
              )}

              {currentMobileMenu === "responsabilidad-social" && (
                <div className="submenu">
                  <a
                    className="back-button"
                    onClick={() => goBackToMainMenu("main")}
                  >
                    <img
                      className="back-arrow"
                      src="/assets/icons/arrow_right.svg"
                      alt=""
                    />
                    Main menu
                  </a>
                  <div className="subMenuTitle">
                    <h3>Responsabilidad Social</h3>
                  </div>
                  <ul>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/fundacion-holcim-mexico-ac`}
                      >
                        Fundación Holcim México A.C.
                      </a>
                    </li>
                    <li>
                      <a
                        className="submenu-item"
                        href={`${baseUrl}/escuela-mexicana-de-la-construccion`}
                      >
                        Escuela Mexicana de la Construcción
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
